import React from "react";
import { upperCase } from "lodash";

import { Paragraph, Tooltip } from "@tvg/design-system";
import { formatCurrencyTotal } from "../helpers";
import { CURRENCY_THRESHOLD } from "../constants";

interface BetTotalProps {
  label: string;
  value: number;
  qaLabel: string;
  isCurrency?: boolean;
  currencyThreshold?: number;
}

const BetTotal = ({
  label,
  value,
  qaLabel,
  isCurrency = false,
  currencyThreshold = CURRENCY_THRESHOLD
}: BetTotalProps) => (
  <>
    {isCurrency && value > currencyThreshold ? (
      <Tooltip
        qaLabel="tooltip-amount"
        content={value.toString()}
        placement="bottom-mid"
      >
        <Paragraph
          qaLabel={`${qaLabel}-value`}
          color="grey.900"
          fontWeight="bold"
          ml="space-5"
          accessibilityRole="text"
        >
          {formatCurrencyTotal(value, currencyThreshold)}
        </Paragraph>
      </Tooltip>
    ) : (
      <Paragraph
        qaLabel={`${qaLabel}-value`}
        color="grey.900"
        fontWeight="bold"
        ml="space-5"
        accessibilityRole="text"
      >
        {isCurrency
          ? formatCurrencyTotal(value, currencyThreshold)
          : `${value}`}
      </Paragraph>
    )}

    <Paragraph
      qaLabel={`${qaLabel}-label`}
      color="grey.800"
      fontFamily="condensedRegular"
      fontSize="xs"
      ml="space-2"
      accessibilityRole="text"
    >
      {upperCase(label)}
    </Paragraph>
  </>
);

export default BetTotal;
